"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
exports.cube = (size = 0.5) => {
    const geometry = new THREE.BoxGeometry(size, size, size);
    for (let i = 0; i < geometry.faces.length; i += 2) {
        const hex = Math.random() * 0xffffff;
        geometry.faces[i].color.setHex(hex);
        geometry.faces[i + 1].color.setHex(hex);
    }
    const material = new THREE.MeshBasicMaterial({
        vertexColors: THREE.FaceColors,
        overdraw: 0.5
    });
    return new THREE.Mesh(geometry, material);
};
exports.customShape = () => {
    const geom = new THREE.Geometry();
    const v1 = new THREE.Vector3(0, 0, 0);
    const v2 = new THREE.Vector3(2, 0, 0);
    const v3 = new THREE.Vector3(0, 2, 0);
    const v4 = new THREE.Vector3(0, 0, -2);
    geom.vertices.push(v1);
    geom.vertices.push(v2);
    geom.vertices.push(v3);
    geom.vertices.push(v4);
    const face0 = new THREE.Face3(0, 1, 2);
    const face1 = new THREE.Face3(1, 2, 3);
    const face2 = new THREE.Face3(0, 3, 1);
    const face3 = new THREE.Face3(0, 3, 2);
    face0.color = new THREE.Color(0xaaaaaa);
    face1.color = new THREE.Color(0xcccccc);
    face2.color = new THREE.Color(0xeeeeee);
    face3.color = new THREE.Color(0xffffff);
    geom.faces.push(face0);
    geom.faces.push(face1);
    geom.faces.push(face2);
    geom.faces.push(face3);
    geom.computeFaceNormals();
    return new THREE.Mesh(geom, new THREE.MeshPhysicalMaterial({
        side: THREE.DoubleSide,
        vertexColors: THREE.FaceColors
    }));
};
exports.calcNormal = (vertices) => vertices[1]
    .clone()
    .sub(vertices[0])
    .cross(vertices[2].clone().sub(vertices[0]))
    .normalize();



// WEBPACK FOOTER //
// ./src/components/three/util.ts